<template>
  <div id="new_user" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div class="title">
        <h2>登録情報確認</h2>
      </div>
      <section v-if="isAdmin">
        <div class="title_flex_btn">
          <p class="text_size_big bold">企業情報</p>
          <button type="submit" class="main_btn" @click="editCorp">修正する</button>
        </div>
        <dd-corp-confirm
          ref="dd-corp-confirm"
          :corpForm="corpForm"
          :isEdit="true"
        />
      </section>
      <section>
        <div class="title_flex_btn">
          <p class="text_size_big bold">アカウント情報</p>
          <button type="submit" class="main_btn" @click="editAccount">修正する</button>
        </div>
        <div class="input_list">
          <ul>
            <li>
              <span class="list_line item_title text_right">
                <label>メールアドレス：</label>
              </span>
              <span class="list_line">
                <label>{{accountForm.email}}</label>
              </span>
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div class="title_flex_btn">
          <p class="text_size_big bold">パスワード</p>
          <button type="submit" class="main_btn" @click="editPassword">修正する</button>
        </div>
        <div class="input_list">
          <ul>
            <li>
              <span class="list_line item_title text_right">
                <label>パスワード：</label>
              </span>
              <span class="list_line">
                <label>********</label>
              </span>
            </li>
          </ul>
        </div>
      </section>
      <section>
        <div class="title_flex_btn">
          <p class="text_size_big bold">ユーザー情報</p>
          <button type="submit" class="main_btn" @click="editUser">修正する</button>
        </div>
        <dd-user-confirm
          ref="dd-user-confirm"
          :userForm="userForm"
          :isEdit="true"
        />
      </section>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as App from '../../utils/App'
import * as Api from '../../utils/Api'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import {USER_TYPE} from '../constants/TypeEc'

// Module
import Header from '../components/common/DcHeader'
import CorpConfirm from '../components/user/CorpConfirm'
import UserConfirm from '../components/user/UserConfirm'

export default {
  name: 'UpdateUserConfirm',
  components: {
    'dd-header': Header,
    'dd-corp-confirm': CorpConfirm,
    'dd-user-confirm': UserConfirm
  },
  props: {
  },
  data () {
    return {
      corpForm: {
        corpName: '',
        corpBranchName: '',
        email: '',
        tel: '',
        fax: '',
        postcd: '',
        state: '',
        city: '',
        street: ''
      },
      accountForm: {
        email: ''
      },
      userForm: {
        corpType: '',
        corpDept: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        userType: '',
        infosrc: '',
        recvInfo: '',
        consent: ''
      },
      errorMessage: { text: '' },
      validateErrorMessages: {}
    }
  },
  computed: {
    isAdmin: function () {
      if (this.userForm.userType === USER_TYPE.DC_ADMIN.code) {
        return true
      }
      return false
    }
  },
  methods: {
    fetchData: function () {
      let payload = {
      }
      axios.post(DC_URL.USER + '/edit', payload)
        .then(response => {
          if (response.data.errorMessage) {
            this.handleErrorMessage(response)
          } else {
            this.$set(this.corpForm, 'corpName', response.data.data.corpName)
            this.$set(this.corpForm, 'corpBranchName', response.data.data.branch)
            this.$set(this.corpForm, 'email', response.data.data.email)
            this.$set(this.corpForm, 'tel', response.data.data.tel)
            this.$set(this.corpForm, 'fax', response.data.data.fax)
            this.$set(this.corpForm, 'postcd', response.data.data.postcd)
            this.$set(this.corpForm, 'state', response.data.data.state)
            this.$set(this.corpForm, 'city', response.data.data.city)
            this.$set(this.corpForm, 'street', response.data.data.street)

            this.$set(this.accountForm, 'email', response.data.data.userList[0].email)

            this.$set(this.userForm, 'corpType', response.data.data.userList[0].corpType)
            this.$set(this.userForm, 'corpDept', response.data.data.userList[0].userDepartment)
            this.$set(this.userForm, 'userLastName', response.data.data.userList[0].userLastName)
            this.$set(this.userForm, 'userFirstName', response.data.data.userList[0].userFirstName)
            this.$set(this.userForm, 'userLastNameKana', response.data.data.userList[0].userLastNameKana)
            this.$set(this.userForm, 'userFirstNameKana', response.data.data.userList[0].userFirstNameKana)
            this.$set(this.userForm, 'userType', response.data.data.userList[0].userType)
            this.$set(this.userForm, 'infosrc', response.data.data.userList[0].infosrc)
            this.$set(this.userForm, 'inviteCode', response.data.data.userList[0].inviteCode)
            this.$set(this.userForm, 'recvInfo', response.data.data.userList[0].recvInfo)

            App.setLocalStorage(DC_STORAGE_KEY.CORP_DATA, this.corpForm)
            App.setLocalStorage(DC_STORAGE_KEY.ACCOUNT_DATA, this.accountForm)
            App.setLocalStorage(DC_STORAGE_KEY.USER_DATA, this.userForm)
          }
        }).catch(error => {
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
        })
    },
    editCorp: function () {
      this.$router.push({
        name: 'UpdateCorpInput'
      })
    },
    editUser: function () {
      this.$router.push({
        name: 'UpdateUserInput'
      })
    },
    editAccount: function () {
      this.$router.push({
        name: 'UpdateAccountInput'
      })
    },
    editPassword: function () {
      this.$router.push({
        name: 'UpdatePasswordInput'
      })
    },
    close: function () {
      this.$router.push('/mmstyle/top')
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  mounted: function () {
    this.fetchData()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdateUserConfirm.vue